import React from 'react';
import PropTypes from 'prop-types';
import ProductPage from 'components/ProductPage';

const propTypes = {
  data: PropTypes.shape({ marketTapProduct: PropTypes.object }).isRequired,
};

function ProductPageContainer({ data }) {
  return <ProductPage product={data.marketTapProduct} />;
}

ProductPageContainer.propTypes = propTypes;

export default ProductPageContainer;

export const query = graphql`
  query ProductQuery($id: String!) {
    marketTapProduct(id: { eq: $id }) {
      name
      id
      slug
      quantityVariable
      excerpt
      productCategories {
        name
        slug
      }
      productCategoryIds
      description
      benefitsAndDeliverables
      bannerImageUrl {
        full
      }
      prices {
        cad {
          price
          formattedPrice
        }
        usd {
          price
          formattedPrice
        }
      }
      seoTitle
      seoKeywords
      seoDescription
      allowRecurringPurchase
      allowMultiplePurchase
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/Product.js